export const initDataBusRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/databus/requests",
          name: "databus-requests",
          component: () => import("@/pages/manage/data-bus/requests/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/databus/responses",
          name: "databus-responses",
          component: () =>
            import("@/pages/manage/data-bus/responses/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
